import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { removeRouterOutletsFromUrl } from '@vendasta/shared';
import { GALAXY_PAGE_OPTIONS, GalaxyPageOptions } from './tokens';

@Injectable({ providedIn: 'root' })
export class PageService {
  private readonly history: (string | null)[];

  showNavToggle = false;
  navToggleTooltip = 'GALAXY.PAGE.TOGGLE_MENU';

  constructor(
    private router: Router,
    @Optional() @Inject(GALAXY_PAGE_OPTIONS) private pageOptions: GalaxyPageOptions | undefined,
  ) {
    this.history = [router.url];
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        while (this.history.length > 0 && this.history[this.history.length - 1] === null) {
          this.history.pop();
        }

        const currentNavigation = this.router.getCurrentNavigation();
        const isReplaceUrl = currentNavigation?.extras?.replaceUrl === true;

        if (currentNavigation?.extras?.skipLocationChange) {
          this.history.push(null);
        } else if (this.history.length === 0 || event.url !== this.history[this.history.length - 1]) {
          const previousUrl = this.history[this.history.length - 1];
          const previousUrlPath = previousUrl?.substring(
            0,
            previousUrl?.indexOf('?') > 0 ? previousUrl?.indexOf('?') : undefined,
          );
          const activeUrl = event.urlAfterRedirects;
          const activeUrlPath = activeUrl?.substring(
            0,
            activeUrl?.indexOf('?') > 0 ? activeUrl?.indexOf('?') : undefined,
          );

          if (previousUrl && previousUrlPath === activeUrlPath) {
            this.history.pop(); // remove the previous url if it is the same as the current url's path without query params
          }

          if (isReplaceUrl && this.history.length > 0) {
            // Replace the last history entry instead of pushing a new one
            this.history[this.history.length - 1] = activeUrl;
          } else {
            this.history.push(activeUrl);
          }
        }
      }
    });

    this.showNavToggle = this.pageOptions?.showToggle || false;
    this.navToggleTooltip = this.pageOptions?.navToggleTooltip || 'GALAXY.PAGE.TOGGLE_MENU';
  }

  getPreviousPageUrl(defaultUrl: string): string {
    if (this.history.length > 1) {
      const previousUrl = this.history[this.history.length - 2];
      // This is to remove any router outlets from the previous url
      return previousUrl ? removeRouterOutletsFromUrl(previousUrl) : '';
    }

    return defaultUrl;
  }

  navigateToPrevious(fallbackUrl: string, activeRoute: ActivatedRoute): void {
    const previousUrl = this.getPreviousPageUrl(fallbackUrl);
    if (previousUrl == fallbackUrl) {
      this.router.navigate([fallbackUrl], { relativeTo: activeRoute });
    } else {
      this.pop();
      this.router.navigate([previousUrl]);
    }
  }

  pop(deleteCount = 2): void {
    this.history.splice(-deleteCount, deleteCount);
  }
}
